import {
  BOW_TIE_BORDER_COLOR,
  BOW_TIE_HORIZONTAL_LINE,
  BOW_TIE_SIDE,
} from '../constants';
import BowTieControlMetadata from './BowTieControlMetadata';
import BowTieControlTooltip from './BowTieControlTooltip';

const controlRail =
  'tw:pointer-events-none tw:absolute tw:inset-y-0 tw:w-px tw:before:absolute tw:before:inset-x-0 tw:before:-top-1.25 tw:before:bottom-1/2 tw:before:bg-[#dfe7ef] tw:group-first/control:before:hidden tw:after:absolute tw:after:inset-x-0 tw:after:top-1/2 tw:after:-bottom-1.25 tw:after:bg-[#dfe7ef] tw:group-last/control:after:hidden';

function ControlContent({ control, side }) {
  const isPreventive = side === BOW_TIE_SIDE.PREVENTIVO;
  const leftConnection = isPreventive
    ? 'tw:-left-2.75 tw:w-2.5'
    : 'tw:-left-2.25 tw:w-2';
  const rightConnection = isPreventive
    ? 'tw:-right-2.25 tw:w-2'
    : 'tw:-right-2.75 tw:w-2.5';

  return (
    <>
      <span
        className={`${BOW_TIE_HORIZONTAL_LINE} ${leftConnection}`}
        aria-hidden="true"
      />
      <span
        className={`${BOW_TIE_HORIZONTAL_LINE} ${rightConnection}`}
        aria-hidden="true"
      />
      <span
        className={`${controlRail} ${
          isPreventive ? 'tw:-left-2.75' : 'tw:-left-2.25'
        }`}
        aria-hidden="true"
      />
      <span
        className={`${controlRail} ${
          isPreventive ? 'tw:-right-2.25' : 'tw:-right-2.75'
        }`}
        aria-hidden="true"
      />
      <span className="tw:line-clamp-2 tw:font-semibold">{control.nome}</span>
      <BowTieControlMetadata control={control} />
    </>
  );
}

function BowTieControl({ control, side, branch, disabled, onClick }) {
  const canOpen = !disabled && Boolean(control?.riscoPontoControleId);
  const className = `tw:group/control tw:relative tw:z-1 tw:flex tw:min-h-13.5 tw:w-full tw:flex-col tw:items-stretch tw:rounded-lg tw:border tw:border-dashed tw:bg-white tw:px-2.5 tw:py-2 tw:text-left tw:text-xs/tight tw:text-gray-800 ${BOW_TIE_BORDER_COLOR[side]}`;
  const content = <ControlContent control={control} side={side} />;
  const card = canOpen ? (
    <button
      type="button"
      className={`${className} tw:cursor-pointer tw:transition-shadow tw:hover:shadow-[0_4px_10px_rgba(31,41,55,0.12)] tw:focus-visible:outline-2 tw:focus-visible:outline-offset-2 tw:focus-visible:outline-[#0d6efd]`}
      onMouseDown={(event) => event.stopPropagation()}
      onClick={() => onClick(control)}
    >
      {content}
    </button>
  ) : (
    <div className={className}>{content}</div>
  );

  return (
    <BowTieControlTooltip control={control} side={side} branch={branch}>
      {card}
    </BowTieControlTooltip>
  );
}

export default BowTieControl;
